export default "__VITE_ASSET__CkHn0_CL__"